(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("price", [], factory);
	else if(typeof exports === 'object')
		exports["price"] = factory();
	else
		root["price"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 